import { render, staticRenderFns } from "./RegistrarFamiliar.vue?vue&type=template&id=80bc81ce&scoped=true&lang=pug"
import script from "./RegistrarFamiliar.vue?vue&type=script&lang=js"
export * from "./RegistrarFamiliar.vue?vue&type=script&lang=js"
import style0 from "./RegistrarFamiliar.vue?vue&type=style&index=0&id=80bc81ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bc81ce",
  null
  
)

export default component.exports